/**
 * Generated runtime TestId mirror for frontend/src/pages/RoleAssignments.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RoleAssignmentsTestIds = {
  colAssignedRoles: "col-assigned-roles",
  colEmail: "col-email",
  colName: "col-name",
  colStatus: "col-status",
  colType: "col-type",
  roleAssignmentsList: "role-assignments-list",
  userEmail: (user_id: string) => `user-email-${user_id}`,
  userEmailPrefix: () => "user-email-" as TestIdPrefix,
  userName: (user_id: string) => `user-name-${user_id}`,
  userNamePrefix: () => "user-name-" as TestIdPrefix,
  userRoles: (user_id: string) => `user-roles-${user_id}`,
  userRolesPrefix: () => "user-roles-" as TestIdPrefix,
  userRow: (user_id: string) => `user-row-${user_id}`,
  userRowPrefix: () => "user-row-" as TestIdPrefix,
  userStatus: (user_id: string) => `user-status-${user_id}`,
  userStatusPrefix: () => "user-status-" as TestIdPrefix,
  userTypeBadge: (user_id: string) => `user-type-badge-${user_id}`,
  userTypeBadgePrefix: () => "user-type-badge-" as TestIdPrefix,
  userRoleBadge: (user_id: string, role_id: string) => `user-role-badge-${user_id}-${role_id}`,
  userRoleBadgePrefix: () => "user-role-badge-" as TestIdPrefix
} as const;
